import {Component} from '@angular/core';
import * as moment from 'moment';
import {ConfigService} from '../../../services/config.service';

@Component({
    selector: 'footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

    footerText: string;
    versionText: string;

    constructor(private config: ConfigService) {
        this.versionText = `v${config.version}`;
        this.footerText = `COPYRIGHT © ${moment().year()} MOBIT - TODOS OS DIREITOS RESERVADOS`;
    }
}
